import fetch from '../utils/fetch';

export function deliveryAdminListAllDeliveryCompany() {
  return fetch.post('/order/api/orderDelivery/listAllDeliveryCompany', {});
}
